export default "__VITE_ASSET__Dszu0zbz__"